<template>
  <div class="x-tops" :style="{ width: isCollapse ? '60px' : '230px' }">
    <div class="x-title">
      <span v-if="isCollapse">C</span>
      <span v-else>
        <img :src="require('@/assets/logo_new.png')" alt="Carousel Image" class="logo-img" @click='goToIndex'>
        <!-- 联合快递LTL系统 -->
      </span>
    </div>
    <div class="menu-wrapper">
      <el-menu
      :default-active="$route.path"
      class="el-menu-vertical-demo"
      :collapse="isCollapse"
      unique-opened
      background-color="#409EFF"
      text-color="#fff"
      active-text-color="#fff"
      router
    >
      <div v-for="(item, index) in visibleNav" :key="index">
        <el-submenu :index="item.url" v-if="item.ischildren">
          <template slot="title">
            <i :class="item.icon"></i>
            <span slot="title" v-if="!isCollapse">{{ $t(`layout.side.${item.key}`) }}</span>
          </template>
          <el-menu-item
            :index="item1.url"
            v-for="(item1, index1) in item.children"
            :key="index1"
            >{{ $t(`layout.side.${item1.key}`) }}</el-menu-item
          >
        </el-submenu>
        <el-menu-item :index="item.url" v-else>
          <i :class="item.icon"></i>
          <span slot="title">{{ $t(`layout.side.${item.key}`) }}</span>
        </el-menu-item>
      </div>
    </el-menu>
    </div>
  </div>
</template>

<script>
import { getSysConfig } from '@/api/common';
export default {
  data() {
    return {
      isCollapse: false,
      ltlHidden: false,
      nav: [
        // {
        //   uid: 2,
        //   icon: "el-icon-document-checked",
        //   key: "internationalOrder",
        //   name: "国际订单",
        //   url: "/order/fplace",
        //   ischildren: false,
        // },
        // {
        //   uid: 5,
        //   icon: "el-icon-notebook-1",
        //   key: "financialManagement",
        //   name: "财务管理",
        //   url: "5",
        //   ischildren: true,
        //   children: [
        //     {
        //       uid: 7,
        //       icon: "el-icon-location",
        //       key: "creditFlow",
        //       name: "信用流水",
        //       url: "/finance/credit",
        //     },
        //   ],
        // },
        // {
        //   uid: 10,
        //   icon: "el-icon-setting",
        //   key: "accountManagement",
        //   name: "账号管理",
        //   url: "10",
        //   ischildren: true,
        //   children: [
        //     // {
        //     //   uid: 9,
        //     //   icon: "el-icon-location",
        //     //   key: "memberCenter",
        //     //   name: "会员中心",
        //     //   url: "/member",
        //     // },
        //     {
        //       uid: 10,
        //       icon: "el-icon-location",
        //       key: "personalInfo",
        //       name: "个人信息",
        //       url: "/info",
        //     },
        //     {
        //       uid: 11,
        //       icon: "el-icon-location",
        //       key: "changePassword",
        //       name: "修改密码",
        //       url: "/password",
        //     }
        //   ],
        // },
        // ltl
        {
          uid: 1,
          icon: "el-icon-reading",
          key: "home",
          name: "首页",
          url: "/ltl/index",
          ischildren: false,
        },       
        {
          uid: 30,
          icon: "el-icon-cpu",
          key: "AIOrderForm",
          name: "AI自动填单",
          url: "/AIorder/form",
          ischildren: false,
        }, 
        {
          uid: 31,
          icon: "el-icon-collection",
          key: "AIOrderList",
          name: "AI订单列表",
          url: "/AIorder/list",
          ischildren: false,
        }, 
        {
          uid: 2,
          icon: "el-icon-document-add",
          key: "createDomesticWaybill",
          name: "新建国内快递面单",
          url: "/bill/place",
          ischildren: false,
        }, 
        {
          uid: 3,
          icon: "el-icon-document-remove",
          key: "createInternationalWaybill",
          name: "新建国际快递面单",
          url: "/bill/fplace",
          ischildren: false,
        }, 
        {
          uid: 4,
          icon: "el-icon-tickets",
          key: "expressOrderManagement",
          name: "快递订单管理",
          url: "/bill/list",
          ischildren: false,
        },
        {
          uid: 5,
          icon: "el-icon-location-information",
          key: "expressAddressManagement",
          name: "快递地址管理",
          url: "/bill/address",
          ischildren: false,
        }, 
        {
          uid: 5,
          icon: "el-icon-printer",
          key: "invoiceList",
          name: "发票列表",
          url: "/bill/invoice",
          ischildren: false,
        }, 
        {
          uid: 26,
          icon: "el-icon-map-location",
          key: "findStores",
          name: "查找门店",
          url: "/bill/stores",
          ischildren: false,
        },
        {
          uid: 6,
          icon: "el-icon-document",
          key: "ltlOrderManagement",
          name: "LTL订单管理",
          url: "2",
          ischildren: true,
          module: "ltl",
          children: [
            {
              uid: 7,
              icon: "el-icon-tickets",
              key: "orderList",
              name: "订单列表",
              url: "/ltl/orderList",
            },
          ],
        },
        {
          uid: 8,
          icon: "el-icon-coin",
          key: "ltlQuoteManagement",
          name: "LTL报价管理",
          url: "4",
          ischildren: true,
          module: "ltl",
          children: [
            {
              uid: 9,
              icon: "el-icon-location",
              key: "onlineQuote",
              name: "在线报价",
              url: "/ltl/orderPlace",
            },
            {
              uid: 10,
              icon: "el-icon-location",
              key: "quoteList",
              name: "报价列表",
              url: "/ltl/rateList",
            },
            {
              uid: 11,
              icon: "el-icon-location",
              key: "fbaQuote",
              name: "FBA报价",
              url: "/ltl/FBA",
            },
          ],
        },       
        {
          uid: 12,
          icon: "el-icon-news",
          key: "ltlProductManagement",
          name: "LTL产品管理",
          url: "/ltl/product",
          ischildren: false,
          module: "ltl",
        },          
        {
          uid: 13,
          icon: "el-icon-location-information",
          key: "ltlAddressManagement",
          name: "LTL地址管理",
          url: "/ltl/address",
          ischildren: false,
          module: "ltl",
        },   
        {
          uid: 14,
          icon: "el-icon-wallet",
          key: "myFinance",
          name: "我的财务",
          url: "8",
          ischildren: true,
          children: [
            {
              uid: 15,
              icon: "el-icon-location",
              key: "expressConsumptionFlow",
              name: "快递消费流水",
              url: "/bill/consumption",
            },
            {
              uid: 27,
              icon: "el-icon-bank-card",
              key: "expressRecharge",
              name: "快递充值",
              url: "/bill/recharge",
            },
            // {
            //   uid: 15,
            //   icon: "el-icon-location",
            //   key: "invoiceList",
            //   name: "快递发票列表",
            //   url: "/bill/invoice",
            // },
            {
              uid: 16,
              icon: "el-icon-location",
              key: "ltlRechargeManagement",
              name: "LTL充值管理",
              url: "/ltl/recharge",
              module: "ltl",
            },
            {
              uid: 17,
              icon: "el-icon-location",
              key: "ltlFinancialDetails",
              name: "LTL财务明细",
              url: "/ltl/finance",
              module: "ltl",
            },
            {
              uid: 18,
              icon: "el-icon-location",
              key: "ltlInvoiceManagement",
              name: "LTL发票管理",
              url: "/ltl/invoice",
              module: "ltl",
            },
          ],
        },        
        
        {
          uid: 19,
          icon: "el-icon-close-notification",
          key: "announcementList",
          name: "公告列表",
          url: "/ltl/news",
          ischildren: false,
        },          
        {
          uid: 20,
          icon: "el-icon-document-remove",
          key: "myWorkOrder",
          name: "我的工单",
          url: "/ltl/workOrder",
          ischildren: false,
        },          
        {
          uid: 21,
          icon: "el-icon-document-remove",
          key: "serviceProviderList",
          name: "服务商列表",
          url: "/bill/facilitator/list",
          ischildren: false,
        }, 
        // {
        //   uid: 22,
        //   icon: "el-icon-c-scale-to-original",
        //   key: "calculator",
        //   name: "计算器",
        //   url: "/bill/calc",
        //   ischildren: false,
        // }, 
        {
          uid: 23,
          icon: "el-icon-setting",
          key: "accountManagement",
          name: "账号管理",
          url: "10",
          ischildren: true,
          children: [
            // {
            //   uid: 9,
            //   icon: "el-icon-location",
            //   key: "memberCenter",
            //   name: "会员中心",
            //   url: "/member",
            // },
            {
              uid: 24,
              icon: "el-icon-location",
              key: "personalInfo",
              name: "个人信息",
              url: "/bill/info",
            },
            {
              uid: 25,
              icon: "el-icon-location",
              key: "changePassword",
              name: "修改密码",
              url: "/bill/password",
            }
          ],
        },
        // {
        //   uid: 22,
        //   icon: "el-icon-user",
        //   key: "personalCenter",
        //   name: "个人中心",
        //   url: "/ltl/user",
        //   ischildren: false,
        // }, 
        // {
        //   uid: 17,
        //   icon: "el-icon-tickets",
        //   key: "test",
        //   name: "测试",
        //   url: "/ce",
        //   ischildren: false,
        // } 
      ],
    };
  },
  computed: {
    visibleNav() {
      if (!this.ltlHidden) return this.nav;
      const result = [];
      this.nav.forEach((item) => {
        if (item.module === 'ltl') return; // 整项隐藏
        if (item.ischildren && Array.isArray(item.children)) {
          const filteredChildren = item.children.filter((c) => c.module !== 'ltl');
          if (filteredChildren.length === 0) return; // 子项全为 LTL，父项一并隐藏
          result.push({ ...item, children: filteredChildren });
        } else {
          result.push(item);
        }
      });
      return result;
    },
  },
  created() {
    this.fetchSysConfig();
  },
  methods: {
    // 接收顶部切换折叠
    receiveData(e) {
      this.isCollapse = e;
    },
    goToIndex(){
      // this.$router.push({ path: '/'});
      this.$router.push({ path: '/ltl/index'});
    },
    // 实时获取系统开关，决定是否隐藏 LTL 菜单
    fetchSysConfig() {
      getSysConfig().then((res) => {
        if (res && res.code == 1 && res.data) {
          this.ltlHidden = Number(res.data.ltl_switch) === 1;
        }
      }).catch(() => {
        // 接口异常时兜底为不隐藏
        this.ltlHidden = false;
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.x-tops {
  height: 100vh;
  background: #409EFF;
  overflow: hidden;
}
.menu-wrapper {
  height: calc(100vh - 50px); /* 减去顶部标题的高度 */
  width: 230px;
  overflow: hidden;
  position: relative;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 230px;
  height: 100%;
  text-align: left;
  overflow-y: scroll;
}
/* 隐藏滚动条 */
.el-menu-vertical-demo::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera */
}

.el-menu-vertical-demo {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
/deep/.el-menu-item.is-active {
  border-left: 4px solid #E6A23C;
  background: rgb(7, 123, 243) !important;
}
/deep/.el-menu-item i,/deep/.el-submenu__title i{
  color: #fff;
  opacity: 0.8;
}
/deep/.el-menu{
  border: none;
}
.logo-img{
  display: block;
  width: 100%;
  height: 50px;
  cursor: pointer;
  object-fit: contain;
  background: #fff;
}
.x-title {
  height: 50px;
  width: 100%;
  text-align: center;
  line-height: 50px;
  font-size: 20px;
  font-weight: bold;
  color: #fff;
  overflow: hidden;
  span {
    // font-family: Avenir, Helvetica, Arial, sans-serif;
    font-family: Chinese Quote, -apple-system, BlinkMacSystemFont, Segoe UI,
      PingFang SC, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica,
      Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol;
  }
}
</style>